<template>
  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
  <router-view />
</template>
<script setup>

</script>
<style lang="less"></style>
